var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-link',{attrs:{"type":"primary","href":`https://facebook.com/${_vm.row.page_id}`,"target":"_blank"}},[_vm._v(_vm._s(_vm.row.page_name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }